<template>
    <BlockUI :blocked="isLoading">
        <Fluid class="field">
            <label for="name">Name</label>
            <InputText
                id="name"
                autofocus
                v-model="newName"
                required
                :value="newName"
                style="width: 100%"
            />
        </Fluid>
        <Fluid class="field" v-if="!editEntity">
            <label for="description">Description</label>
            <InputText
                id="description"
                v-model="newDescription"
                required
                style="width: 100%"
            />
        </Fluid>
        <div class="buttons">
            <Button label="Cancel" text severity="secondary" @click="cancel" />
            <Button label="Save" severity="primary" @click="closeAndSave" />
        </div>
    </BlockUI>
</template>
<script setup lang="ts">
import {
    BusinessEntity,
    useBusinessEntitiesStore,
} from "@/stores/business-entities-store";
import { storeToRefs } from "pinia";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { Ref, inject, onMounted, ref } from "vue";
import InputText from "primevue/inputtext";
import { useHotKeys } from "@/composables/hotkeys";

const { createEntity, updateEntity } = useBusinessEntitiesStore();
const { statusCode, isLoading } = storeToRefs(useBusinessEntitiesStore());
const { addHotKey } = useHotKeys();

const editEntity = ref<BusinessEntity | undefined>();
const newName = ref("");
const newDescription = ref("");

const dialogRef = inject<Ref<DynamicDialogInstance>>("dialogRef");
const cancel = () => dialogRef?.value.close();

/**
 * Save on cmd/ctrl + enter.
 */
addHotKey("ControlOrMeta+Enter", async () => {
    await closeAndSave();
});

const closeAndSave = async () => {
    if (editEntity.value) {
        await updateEntity({
            identity: editEntity.value.identity,
            name: newName.value,
        });
    } else {
        await createEntity(newName.value, newDescription.value);
    }
    if (statusCode.value && statusCode.value < 300) {
        dialogRef?.value?.close();
    }
};

onMounted(() => {
    editEntity.value = dialogRef?.value?.data;
    if (editEntity.value) {
        newName.value = editEntity.value.name;
    }
});
</script>

<style lang="scss" scoped>
.field {
    padding-bottom: 1em;

    label {
        display: block;
        margin-bottom: 0.5em;
    }
}

.buttons {
    display: flex;
    justify-content: end;
    margin-top: 1em;
    gap: 1em;
}
</style>
